module.exports = __webpack_public_path__ + "img/banner.050a82b3.png";